/**
 * @file Purchase Album Header container.
 */

import { compose } from 'redux';
import { connect } from 'react-redux';

import PurchaseAlbumHeader from '../../components/purchase/PurchaseAlbumHeader';
import { openModal } from '../../actions/modal-actions';

const mapDispatchToProps = {
  openModal,
};

export default compose(connect(null, mapDispatchToProps))(PurchaseAlbumHeader);
